import { combineReducers } from 'redux';
import { WidgetType } from 'widgets/WidgetType';
import { createWidgetsReducer } from 'widgets/store/widgetsReducerFactory';
import { buildEstimatedTradeCostWidgetConfigSlice } from 'widgets/estimatedTradeCost/widget/store/configslice';
import { EstimatedTradeCostState } from 'widgets/estimatedTradeCost/widget/store/EstimatedTradeCostState';
import { EstimatedTradeCostActionPayload } from 'widgets/estimatedTradeCost/widget/store/actions';
import { buildEstimatedTradeCostWidgetComponentSlice } from 'widgets/estimatedTradeCost/widget/store/componentSlice';

const { reducer: configReducer } = buildEstimatedTradeCostWidgetConfigSlice();
const { reducer: componentReducer } =
    buildEstimatedTradeCostWidgetComponentSlice();

const estimatedTradeCostWidgetReducer =
    combineReducers<EstimatedTradeCostState>({
        component: componentReducer,
        config: configReducer,
    });

export const estimatedTradeCostWidgetsReducer = createWidgetsReducer<
    EstimatedTradeCostState,
    EstimatedTradeCostActionPayload
>(WidgetType.EST_TRADE_COST_WIDGET, estimatedTradeCostWidgetReducer);
